import React from 'react';
import PropTypes from 'prop-types';
import {Message} from 'semantic-ui-react';
import {defineMessages, useIntl} from 'react-intl';
import imageBlockSVG from '@plone/volto/components/manage/Blocks/Image/block-image.svg';
import {isInternalURL} from '@plone/volto/helpers/Url/Url';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import cx from 'classnames';
import config from '@plone/volto/registry';

const messages = defineMessages({
    PleaseChooseContent: {
        id: 'Please choose an existing content as source for this element',
        defaultMessage:
            'Please choose an existing content as source for this element',
    },
    readMore: {
        id: 'Read more',
        defaultMessage: 'Read more',
    },
});

const TeaserDefaultTemplate = (props) => {
    const {className, data, isEditMode, style} = props;
    const intl = useIntl();
    const href = data.href?.[0];
    const image = data.preview_image?.[0];
    const url = data.preview_image?.[0]?.['@id'];

    const Image = config.getComponent('Image').component;
    const {openExternalLinkInNewTab} = config.settings;
    const hrefId = href?.['@id'];
    const target =
        data.openLinkInNewTab ||
        (openExternalLinkInNewTab && hrefId && !isInternalURL(hrefId))
            ? '_blank'
            : null;

    return (
        <div className={cx('block teaser', className)} style={style}>
            <>
                {!href && isEditMode && !data.overwrite && (
                    <Message>
                        <div className="teaser-item placeholder">
                            <img src={imageBlockSVG} alt=""/>
                            <p>{intl.formatMessage(messages.PleaseChooseContent)}</p>
                        </div>
                    </Message>
                )}
                {(href || data.overwrite) && (
                    <div className="teaser-shape">
                        <div className="teaser-item default">
                            {url && !image?.image_field ? (
                                <div className="image-wrapper">
                                    <Image src={url} alt="" loading="lazy" responsive={true}/>
                                </div>
                            ) : (
                                (href?.hasPreviewImage || href?.image_field || image) && (
                                    <div className="image-wrapper">
                                        <Image
                                            item={image || href}
                                            imageField={image ? image.image_field : href?.image_field}
                                            alt=""
                                            loading="lazy"
                                            responsive={true}
                                        />
                                    </div>
                                )
                            )}
                            <div className="content">
                                {data.head_title && (
                                    <h2 className="teaser-headline">{data.head_title}</h2>
                                )}

                                {data.title && (
                                    <h3 className="title">{data.title}</h3>
                                )}

                                {!data.hide_description && (
                                    <p className="description">{data.description}</p>
                                )}

                                {!data.hideButton && hrefId && (
                                    <div className="teaser-cta">
                                        <UniversalLink
                                            href={hrefId}
                                            target={target}
                                            className="ui button primary"
                                        >
                                            {data.buttonText || intl.formatMessage(messages.readMore)}
                                        </UniversalLink>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </>
        </div>
    );
};

TeaserDefaultTemplate.propTypes = {
    data: PropTypes.objectOf(PropTypes.any).isRequired,
    isEditMode: PropTypes.bool,
};

export default TeaserDefaultTemplate;
